import { deepCopy } from '../../../../../shared/utils';
import { ReduxAsyncActionsService } from '../../services/ReduxAsyncActions.service';
import type { WrappedReducer } from '../../types/ReduxAsyncActions.types';
import {
  type AppStoreAction,
  CLEAR_APP_STORE,
  CLEAR_PAM_NOTIFICATION_CONFIG,
  FETCH_ANDROID_APP_NAME,
  FETCH_IOS_APP_NAME,
  FETCH_PAM_NOTIFICATION_CONFIG,
  FETCH_QR_CODE_SETTINGS,
  GET_APP_ATTRIBUTION_LIFT,
} from './actions';
import { INIT_STATE } from './constants/appStoreInitState';
import type { AppStoreState } from './types';

const handler = (state: WrappedReducer<AppStoreState>, action: AppStoreAction): WrappedReducer<AppStoreState> => {
  switch (action.type) {
    case CLEAR_APP_STORE: {
      return deepCopy(INIT_STATE);
    }
    case FETCH_ANDROID_APP_NAME.response: {
      return { ...state, androidAppName: action.data.androidAppName };
    }
    case FETCH_IOS_APP_NAME.response: {
      return { ...state, iosAppName: action.data.iosAppName };
    }
    case FETCH_QR_CODE_SETTINGS.response: {
      return { ...state, qrCodeSettings: action.data.qrCodeSettings };
    }
    case GET_APP_ATTRIBUTION_LIFT.response: {
      const attributionLift = action.data;
      return { ...state, attributionLift };
    }
    case FETCH_PAM_NOTIFICATION_CONFIG.request: {
      const pamNotificationConfig = {
        ...state.pamNotificationConfig,
        loading: true,
      };
      return { ...state, pamNotificationConfig };
    }
    case FETCH_PAM_NOTIFICATION_CONFIG.response: {
      if ('skip' in action.data) {
        const pamNotificationConfig = {
          ...state.pamNotificationConfig,
          loading: false,
        };
        return { ...state, pamNotificationConfig };
      }
      const pamNotificationConfig = {
        loading: false,
        cachedTimestamp: new Date(),
        data: action.data,
      };
      return { ...state, pamNotificationConfig };
    }
    case CLEAR_PAM_NOTIFICATION_CONFIG: {
      return { ...state, pamNotificationConfig: { loading: false } };
    }
    default: {
      return state;
    }
  }
};

const AppStoreReducer = ReduxAsyncActionsService.wrapReducer(INIT_STATE, handler, {
  request: [FETCH_ANDROID_APP_NAME, FETCH_IOS_APP_NAME, FETCH_QR_CODE_SETTINGS],
  error: [FETCH_ANDROID_APP_NAME, FETCH_IOS_APP_NAME, FETCH_QR_CODE_SETTINGS],
});

export default AppStoreReducer;
